import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Tab from '../../tabs/tabs';
import GuidBillings from './guidBillings/GuidBillings';
import GuidPayouts from './guidPayouts/GuidPayouts';

const OrgGuidBillings = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('Billing');

    useEffect(() => {
        if (location.pathname.startsWith('/org/g/payouts')) {
            setActiveTab('Payouts');
        } else {
            setActiveTab('Billing');
        }
    }, [location.pathname]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        navigate(
            tab === 'Billing' ? '/org/g/billing?status=completed&approval=approved&page=1' : '/org/g/payouts?page=1'
        );
    };
    return (
        <>
            <div className='tabContainer bookingSticky'>
                <Tab label='Billing' value={'Billing'} activeTab={activeTab} setActiveTab={handleTabChange} />
                <Tab label='Payouts' value={'Payouts'} activeTab={activeTab} setActiveTab={handleTabChange} />
            </div>
            <div>
                {activeTab === 'Billing' && <GuidBillings />}
                {activeTab === 'Payouts' && <GuidPayouts />}
            </div>
        </>
    );
};

export default OrgGuidBillings;
